import React from 'react';
import { Link } from 'react-router-dom';

function Disclaimer() {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white border-b">
        <div className="max-w-4xl mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center gap-3">
              <img 
                src="https://customer-assets.emergentagent.com/job_internkontroll/artifacts/k46v5h98_Systemklar%20Logo%20med%20Sjekkmerke.png" 
                alt="Systemklar" 
                className="h-8"
              />
            </Link>
            <Link to="/login" className="text-sm text-blue-600 hover:text-blue-700">
              Logg inn
            </Link>
          </div>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-4 py-12">
        <div className="bg-white rounded-xl shadow-sm border p-8 md:p-12">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">Ansvarsfraskrivelse</h1>
          <p className="text-gray-500 mb-8">Sist oppdatert: April 2026</p>

          {/* Main Disclaimer Box */}
          <div className="bg-amber-50 border-2 border-amber-400 rounded-xl p-6 mb-8">
            <div className="flex items-start gap-4">
              <div className="flex-shrink-0 w-12 h-12 bg-amber-100 rounded-full flex items-center justify-center">
                <svg className="w-6 h-6 text-amber-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                </svg>
              </div>
              <div>
                <h2 className="text-xl font-bold text-amber-800 mb-3">Viktig informasjon om Systemklar</h2>
                <p className="text-amber-900 text-lg leading-relaxed mb-3">
                  <strong>Systemklar er et støtteverktøy og garanterer ikke etterlevelse av lover eller forskrifter.</strong>
                </p>
                <p className="text-amber-800">
                  Tjenesten genererer forslag og maler basert på informasjon du oppgir. Tjenesten er 
                  <strong> ikke</strong> en juridisk rådgiver, og vi garanterer <strong>ikke</strong> at 
                  det genererte innholdet oppfyller alle krav i Internkontrollforskriften, Arbeidsmiljøloven 
                  eller andre gjeldende lover og forskrifter.
                </p>
              </div>
            </div>
          </div>

          {/* User Responsibility */}
          <div className="bg-red-50 border border-red-200 rounded-xl p-6 mb-8">
            <h2 className="text-xl font-bold text-red-800 mb-4 flex items-center gap-2">
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              Ditt ansvar som bruker
            </h2>
            <p className="text-red-800 mb-4">
              <strong>Brukeren er fullt ansvarlig for å gjennomgå, tilpasse og validere alt innhold 
              som genereres av Tjenesten før det tas i bruk.</strong>
            </p>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <span className="flex-shrink-0 w-6 h-6 bg-red-200 rounded-full flex items-center justify-center text-red-800 font-bold text-sm">1</span>
                <span className="text-red-700">
                  <strong>Gjennomgang, tilpasning og validering</strong> – Alt innhold som genereres må 
                  gjennomgås, tilpasses og verifiseres av deg før det tas i bruk
                </span>
              </li>
              <li className="flex items-start gap-3">
                <span className="flex-shrink-0 w-6 h-6 bg-red-200 rounded-full flex items-center justify-center text-red-800 font-bold text-sm">2</span>
                <span className="text-red-700">
                  <strong>Lovmessig etterlevelse</strong> – Å sikre at ditt internkontrollsystem faktisk 
                  oppfyller alle krav i gjeldende lover og forskrifter
                </span>
              </li>
              <li className="flex items-start gap-3">
                <span className="flex-shrink-0 w-6 h-6 bg-red-200 rounded-full flex items-center justify-center text-red-800 font-bold text-sm">3</span>
                <span className="text-red-700">
                  <strong>Faglig bistand</strong> – Å innhente nødvendig hjelp fra HMS-rådgivere, 
                  bedriftshelsetjeneste eller andre fagpersoner ved behov
                </span>
              </li>
              <li className="flex items-start gap-3">
                <span className="flex-shrink-0 w-6 h-6 bg-red-200 rounded-full flex items-center justify-center text-red-800 font-bold text-sm">4</span>
                <span className="text-red-700">
                  <strong>Kontinuerlig oppdatering</strong> – Å holde HMS-systemet oppdatert ved 
                  endringer i virksomheten, lovverk eller andre relevante forhold
                </span>
              </li>
            </ul>
            <div className="mt-4 pt-4 border-t border-red-200">
              <p className="text-red-800 font-medium">
                Bruk av Tjenesten skjer på brukerens egen risiko.
              </p>
            </div>
          </div>

          {/* What we do NOT guarantee */}
          <div className="bg-gray-100 border border-gray-300 rounded-xl p-6 mb-8">
            <h2 className="text-xl font-bold text-gray-800 mb-4">Vi garanterer IKKE</h2>
            <ul className="space-y-3 text-gray-700">
              <li className="flex items-center gap-3">
                <svg className="w-5 h-5 text-gray-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
                <span>At generert innhold er feilfritt eller komplett</span>
              </li>
              <li className="flex items-center gap-3">
                <svg className="w-5 h-5 text-gray-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
                <span>At bruk av Systemklar gir lovmessig etterlevelse</span>
              </li>
              <li className="flex items-center gap-3">
                <svg className="w-5 h-5 text-gray-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
                <span>At systemet dekker alle risikoer i din virksomhet</span>
              </li>
              <li className="flex items-center gap-3">
                <svg className="w-5 h-5 text-gray-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
                <span>At AI-generert innhold er juridisk bindende</span>
              </li>
              <li className="flex items-center gap-3">
                <svg className="w-5 h-5 text-gray-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
                <span>At Tjenesten utgjør juridisk, regulatorisk eller profesjonell rådgivning</span>
              </li>
            </ul>
          </div>

          {/* AI Disclaimer */}
          <div className="bg-blue-50 border border-blue-200 rounded-xl p-6 mb-8">
            <h2 className="text-xl font-bold text-blue-800 mb-4 flex items-center gap-2">
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
              </svg>
              Om AI-generert innhold
            </h2>
            <p className="text-blue-800 mb-3">
              Systemklar bruker kunstig intelligens (AI) for å generere forslag til dokumenter, 
              risikovurderinger og andre elementer. AI-generert innhold:
            </p>
            <ul className="space-y-2 text-blue-700">
              <li className="flex items-start gap-2">
                <span className="text-blue-500 mt-1">•</span>
                Er basert på informasjonen du oppgir og generelle maler
              </li>
              <li className="flex items-start gap-2">
                <span className="text-blue-500 mt-1">•</span>
                Kan inneholde feil, unøyaktigheter eller mangler
              </li>
              <li className="flex items-start gap-2">
                <span className="text-blue-500 mt-1">•</span>
                Er ment som et utgangspunkt – ikke et ferdig produkt
              </li>
              <li className="flex items-start gap-2">
                <span className="text-blue-500 mt-1">•</span>
                Må alltid gjennomgås og tilpasses av deg
              </li>
            </ul>
          </div>

          {/* Summary */}
          <div className="text-center p-6 bg-gray-50 rounded-xl">
            <p className="text-lg text-gray-700 font-medium">
              Ved å bruke Systemklar bekrefter du at du forstår og aksepterer at 
              <strong> du har det fulle ansvaret</strong> for å sikre at ditt HMS-system 
              er i samsvar med gjeldende lover og forskrifter.
            </p>
          </div>
        </div>

        {/* Navigation */}
        <div className="mt-8 flex justify-center gap-6 text-sm">
          <Link to="/terms" className="text-blue-600 hover:text-blue-700">
            Vilkår for bruk
          </Link>
          <Link to="/privacy" className="text-blue-600 hover:text-blue-700">
            Personvernerklæring
          </Link>
        </div>
      </main>

      {/* Footer */}
      <footer className="border-t mt-12">
        <div className="max-w-4xl mx-auto px-4 py-6 text-center text-sm text-gray-500">
          © 2025 Valoria Solutions AS. Alle rettigheter reservert.
        </div>
      </footer>
    </div>
  );
}

export default Disclaimer;
